(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoocare-product-essentials"] && !Shopify.designMode) return;
  try {
    
  function openZooCareReviews() {
    if (location.hash !== "#recensioner") return;
    const panel = document.getElementById("recensioner");
    if (!panel) return;
    panel.open = true;
    requestAnimationFrame(() => panel.scrollIntoView({ block: "start" }));
  }
  document.addEventListener("click", (event) => {
    const link = event.target.closest("[data-zc-open-reviews]");
    if (!link) return;
    const panel = document.getElementById("recensioner");
    if (panel) panel.open = true;
  });
  window.addEventListener("hashchange", openZooCareReviews);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", openZooCareReviews, { once: true });
  else openZooCareReviews();

  } catch(e) { console.error(e); }
})();
})();
